import * as moment from 'moment';
import {UserManager} from 'User/UserManager';
import {GlobalManager, GLOBALS} from 'Core/GlobalManager/GlobalManager';
import {FormatConverter} from 'FormatEditor/FormatConverter';
import {LOCAL_STORAGE} from 'Core/Common/Enums/LocalStorageItems';

const WINDOW_DAYS = 7;
const UPDATE_TIME_RANGE = '18:00 - 23:59';
const SOURCE_FORMAT = 'DD/MM/YYYY';
const DISPLAY_TOKEN: 'L' | 'LL' | 'LLL' | 'LLLL' = 'LL';

export class NextPublicationHelper {
    static GetRawValue(): string {
        const user = UserManager.Instance.CurrentUser;
        return (user && user.NextPublicationDate) || '';
    }

    static Parse(value: string): moment.Moment | null {
        if (!value) {
            return null;
        }
        const parsed = moment(value, SOURCE_FORMAT, true);
        return parsed.isValid() ? parsed : null;
    }

    static IsValidFormat(value: string): boolean {
        return !value || NextPublicationHelper.Parse(value) !== null;
    }

    static IsWithinWindow(value: string): boolean {
        const parsed = NextPublicationHelper.Parse(value);
        if (!parsed) {
            return false;
        }
        const today = moment().startOf('day');
        const diff = parsed.startOf('day').diff(today, 'days');
        return diff >= 0 && diff <= WINDOW_DAYS;
    }

    static FormatForDisplay(value: string): string {
        const parsed = NextPublicationHelper.Parse(value);
        if (!parsed) {
            return value;
        }

        const layoutLocale = (FormatConverter.GetLocale() || moment.locale()).toLowerCase();
        const wordsLocale = (GlobalManager.Instance.GetGlobal(GLOBALS.DESKTOP_LANGUAGE) || moment.locale()).toLowerCase();

        const pattern = moment.localeData(layoutLocale).longDateFormat(DISPLAY_TOKEN);
        return `${parsed.locale(wordsLocale).format(pattern)} ${UPDATE_TIME_RANGE}`;
    }

    static IsDismissed(value: string): boolean {
        if (!value) {
            return true;
        }
        const stored = Lockr.get<string>(LOCAL_STORAGE.NEXT_PUBLICATION_DISMISSED);
        return stored === value;
    }

    static Dismiss(value: string): void {
        if (value) {
            Lockr.set(LOCAL_STORAGE.NEXT_PUBLICATION_DISMISSED, value);
        }
    }

    static ShouldShow(value: string): boolean {
        return NextPublicationHelper.IsWithinWindow(value) && !NextPublicationHelper.IsDismissed(value);
    }
}
